export default "/images/eac6ee400aac0d857847508260242706.avif";